import { withRtlSupport } from '@skyscanner-internal/backpack-web/bpk-component-icon';
import AccountCircleIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/account-circle';

const AccountCircleIconRTL = withRtlSupport(AccountCircleIcon);

export default () => (
  <AccountCircleIconRTL viewBox="2 2 20 20" style={{ width: '100%', height: '100%' }} />
);
